import React from 'react';
import { motion } from 'framer-motion'; 
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './to-do-list-app.css';
import toDoListImage from '../../../assets/images/vorteximage.png';

const ToDoListApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Vortex <span>College Fest</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 11th July 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={toDoListImage} alt="To-Do List App" className="project-image" />
          <h2 className="project-subtitle">Vortex College Fest</h2>
          <span className="project-category">Website</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="vortexFest" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://vortex-college-fest.netlify.app/" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/College-Fest-Landing-Page" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "vortexFest",
                title: "Vortex College Fest Website",
                path: "/projects/projectdetail/vortex-college-fest"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
            Welcome to the Vortex College Fest! Here's a detailed explanation of the app features.
          </p>

          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The <strong>Vortex College Fest</strong> is a modern, responsive landing page designed to showcase a college's annual technical and cultural festival. The website provides visitors with event information, schedules, registrations, sponsors, and venue details through an engaging user interface.
          </p>

          <h3 className="section-title">Key Features of the App 🛠️</h3>
        <ul className="feature-list">
                  <li><strong>Hero Section</strong> 🎆 - Attractive landing page with animated hero banner.</li>
                  
                  <li><strong>Events Section</strong> 🎭 - Displays technical, cultural, and fun events.</li>

                  <li><strong>Schedule Timeline</strong> 📅 - Complete event timetable.</li>

                  <li><strong>Responsive Design</strong> 📱 - Optimized for all screen sizes.</li>

                  <li><strong>Registration CTA</strong> 📝 - Quick registration button for participants.</li>

                  <li><strong>Sponsors Section</strong> 🤝 - Highlights official sponsors and partners.</li>

                  <li><strong>Gallery</strong> 📸 - Displays memorable moments from previous editions.</li>
        </ul>

          <h3 className="section-title">How the App Works 🔍</h3>
          <ul className="how-it-works-list">
            <li><strong>Explore Events</strong> 🎯 - Browse technical and cultural competitions.</li>
            <li><strong>View Schedule</strong> 📅 - Check event timings and venue details.</li>
            <li><strong>Register</strong> 📝 - Register for your favorite events.</li>
            <li><strong>Contact Organizers</strong> 📞 - Reach the organizing team easily.</li>
          </ul>

          <h3 className="section-title">Features and Benefits 🚀</h3>
          <ul className="benefits-list">
            <li><strong>Easy Navigation</strong> 🧭 - User-friendly interface.</li>
           <li><strong>Modern Design</strong> 🎨 - Professional festival website layout.</li>
           <li><strong>Responsive Experience</strong> 📱 - Works on mobiles, tablets, and desktops.</li>
           <li><strong>Better Engagement</strong> 🚀 - Attractive sections encourage participation.</li>
          </ul>

          <h3 className="section-title">Technical Details ⚙️</h3>
          <ul className="technical-details-list">
            <li><strong>Frontend</strong> 🖥️ - HTML5, CSS3, JavaScript, React.</li>
            <li><strong>Animations</strong> ✨ - Framer Motion.</li>
            <li><strong>Responsive Layout</strong> 📱 - CSS Flexbox & Grid.</li>
            <li><strong>Deployment</strong> ☁️ - Netlify.</li>
          </ul>

          <h3 className="section-title">Real-Life Applications 🌍</h3>
          <ul className="real-life-applications-list">
            <li><strong>College Events</strong> 🎓 - Annual Fest Websites.</li>
            <li><strong>Hackathons</strong> 💻 - Technology Event Landing Pages.</li>
            <li><strong>Cultural Festivals</strong> 🎭 - Music, Dance & Arts Events.</li>
            <li><strong>Conference Websites</strong> 🌍 - Professional Event Management.</li>
          </ul>

          <h3 className="section-title">Future Features 🔮</h3>
          <ul className="future-features-list">
            <li><strong>Online Registration</strong> 📝 - Register directly through the website.</li>
            <li><strong>Live Countdown</strong> ⏳ - Countdown timer before the event starts.</li>
            <li><strong>Ticket Booking</strong> 🎫 - Event ticket management.</li>
            <li><strong>Admin Dashboard</strong> ⚙️ - Manage participants and schedules.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>The <strong>Vortex College Fest</strong> Landing Page provides an engaging digital experience for showcasing college events. With responsive design, modern UI, event highlights, schedules, galleries, and registration features, it serves as an excellent front-end project demonstrating responsive web development and user interface design.</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToDoListApp;
